import { useEffect } from 'react';
import { GameId } from '@bg-shared/enums/GameId';
import { betAmountEntity } from '../BetAmount.entity';

export const useInitialBetAmount = (
    gameId: GameId,
    inputAmountSequence: number[],
    exactAmount: boolean,
) => {
    useEffect(() => {
        betAmountEntity.store(gameId).init(inputAmountSequence, exactAmount);
    }, []);
};
